export default "__VITE_ASSET__DFProGJP__"